export const planFlag = (plan, key) => [true, 1, "1", "true"].includes(plan?.[key]);
export const planCapacity = (plan, key) => Number(plan?.[key]) > 0;
export const campaignEnabled = (plan, key) => plan?.[key] == null || planFlag(plan, key);

export function initialSteps(plan, isAdmin, facts = {}) {
  if (!plan || !isAdmin) return [];
  const connection = planCapacity(plan, "connections");
  const queues = planCapacity(plan, "queues");
  const automateTo = planFlag(plan, "useIntegrations")
    ? "/queue-integration"
    : planFlag(plan, "useOpenAi")
      ? "/prompts"
      : "/flowbuilders";
  return [
    { id: "queue", to: "/queues", done: !!facts.hasQueue && !!facts.hasGreeting, icon: "tree", show: queues },
    { id: "connection", to: "/connections", done: !!facts.hasConnection && (!queues || !!facts.hasAssignment), icon: "phone", show: connection },
    { id: "invite", to: "/users", done: !!facts.hasInvite, icon: "people", show: Number(plan.users) > 1 },
    { id: "options", to: "/settings", done: !!facts.hasOptions, icon: "split", show: true },
    { id: "prepare", to: "/quick-messages", done: facts.quickCount > 0 || facts.tagCount > 0 || facts.contactCount > 0, icon: "flash", show: true },
    { id: "automate", to: automateTo, done: !!facts.hasAutomation, icon: "ai", optional: true, show: true },
    { id: "store", to: "/negocio", done: !!facts.hasStore, icon: "tag", show: planFlag(plan, "useNegocio") },
    { id: "groups", to: "/groups-wa", done: facts.groupCampaignCount > 0, icon: "send", show: campaignEnabled(plan, "useGroupCampaigns") },
    { id: "status", to: "/status-campaigns", done: facts.statusCampaignCount > 0, icon: "send", show: campaignEnabled(plan, "useStatusCampaigns") },
    { id: "campaigns", to: "/campaigns", done: facts.campaignCount > 0, icon: "send", show: planFlag(plan, "useCampaigns") },
  ].filter(step => step.show).map(step => ({ ...step,
    titleKey: `gettingStarted.steps.${step.id}.title`,
    descKey: `gettingStarted.steps.${step.id}.desc`,
    timeKey: `gettingStarted.steps.${step.id}.time`,
    instructionsKey: `gettingStarted.steps.${step.id}.instructions`,
  }));
}

export function extraGuides(plan, isAdmin, facts) {
  if (!plan) return [];
  // Group/status campaigns default to enabled in the plan model; an explicit false wins.
  const campaignFlag = key => campaignEnabled(plan, key);
  return [
    { id: "quick", to: "/quick-messages", icon: "flash", done: facts.quickCount > 0, show: true },
    { id: "tasks", to: "/todolist", icon: "task", show: true },
    { id: "contacts", to: "/contacts", icon: "people", show: true },
    { id: "helps", to: "/helps", icon: "help", show: true },
    { id: "tags", to: "/tags", icon: "tag", done: facts.tagCount > 0, show: true },
    { id: "kanban", to: "/kanban", icon: "kanban", show: planFlag(plan, "useKanban") },
    { id: "ai", to: "/prompts", icon: "ai", done: facts.promptCount > 0, show: isAdmin && planFlag(plan, "useOpenAi") },
    { id: "campaigns", to: "/campaigns", icon: "send", done: facts.campaignCount > 0, show: isAdmin && planFlag(plan, "useCampaigns") },
    { id: "schedules", to: "/schedules", icon: "schedule", done: facts.scheduleCount > 0, show: planFlag(plan, "useSchedules") },
    { id: "chat", to: "/chats", icon: "forum", show: planFlag(plan, "useInternalChat") },
    { id: "agenda", to: "/appointments", icon: "event", show: facts.canAccessAgenda === true },
    { id: "roles", to: "/users", icon: "lock", done: facts.hasInvite, show: isAdmin && Number(plan.users) > 1 },
    { id: "csat", to: "/settings", icon: "csat", done: facts.csatEnabled, show: isAdmin },
    { id: "negocio", to: "/negocio", icon: "tag", show: isAdmin && planFlag(plan, "useNegocio") },
    { id: "integrations", to: "/queue-integration", icon: "split", show: isAdmin && planFlag(plan, "useIntegrations") },
    { id: "api", to: "/messages-api", icon: "split", show: isAdmin && planFlag(plan, "useExternalApi") },
    { id: "files", to: "/files", icon: "tag", show: planFlag(plan, "useFiles") },
    { id: "groups", to: "/groups-wa", icon: "send", show: isAdmin && campaignFlag("useGroupCampaigns") },
    { id: "status", to: "/status-campaigns", icon: "send", show: isAdmin && campaignFlag("useStatusCampaigns") },
    { id: "flows", to: "/flowbuilders", icon: "tree", show: isAdmin },
  ].filter(card => card.show).map(card => ({ ...card,
    titleKey: `gettingStarted.extras.${card.id}.title`,
    descKey: `gettingStarted.extras.${card.id}.desc`,
    instructionsKey: `gettingStarted.extras.${card.id}.instructions`,
  }));
}
